export type LogoProps = {
  /** `lg` é o tamanho do login e do onboarding. */
  size?: '' | 'lg';
  /** id único do gradiente (dois logos na mesma página precisam de ids diferentes). */
  id?: string;
  /** Mostra o texto LISBOON ao lado do símbolo. */
  withText?: boolean;
};

/** Logo Lisboon: símbolo em gradiente dourado + LISBOON. */
export function Logo({ size = '', id = 'lg', withText = true }: LogoProps) {
  return (
    <span className={`logo ${size}`}>
      <svg viewBox="7 1 36 46" aria-hidden="true">
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#f7c852" />
            <stop offset="1" stopColor="#e6960c" />
          </linearGradient>
        </defs>
        <path
          d="M18 3.5C13.5 15 10 27 12.2 35.5 14.4 43 25 44.6 33 41.2 41 37.6 40.6 27.2 33 23.6 26 20.4 17.6 25.2 19.4 31.4c1.2 4 6.2 5 9 2.2"
          fill="none"
          stroke={`url(#${id})`}
          strokeWidth="4.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {withText && 'LISBOON'}
    </span>
  );
}
